/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CheckPatientResponsibilityWorkflowStatusStatus } from "./CheckPatientResponsibilityWorkflowStatusStatus";
import type { PatientResponsibilityResponse } from "./PatientResponsibilityResponse";

export interface CheckPatientResponsibilityWorkflowStatus {
  status: CheckPatientResponsibilityWorkflowStatusStatus;
  result?: PatientResponsibilityResponse | null;
  error?: string | null;
}
